module.exports = __webpack_public_path__ + "img/benoit3.17728f0d.jpg";